import { Flag } from "semantic-ui-react"

export const createPhonePrefixAdapter = (key: string, name: string, value: any) => {
    return {
        key : key,
        text : `${name} (${value})`,
        flag : key.toLowerCase(),
        value : value,
    }
}